<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="centerImage"><img alt="images" id="img3" src="images/img3.jpg"/></p>
<p class="caption">Members of General Custer Camp No. 4, United Indian War Veterans, at their Los Angeles convention in 1929.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_introduction3.vue?5ae0beca